import React from 'react';
import { Card, CardContent } from './ui/card';
import { Plus } from 'lucide-react';
import { PrimaryButton } from './Buttons';

/**
 * Reusable empty state component
 * Used when lists/tables have no data
 */
const EmptyState = ({ 
  icon: Icon, 
  title, 
  description, 
  actionLabel, 
  onAction,
  showAction = true 
}) => {
  return (
    <Card>
      <CardContent className="pt-6 text-center py-12">
        {Icon && <Icon className="w-12 h-12 text-gray-400 mx-auto mb-4" />}
        {title && <h3 className="text-lg font-semibold text-gray-700 mb-2">{title}</h3>}
        {description && <p className="text-gray-500 mb-4">{description}</p>}
        {showAction && actionLabel && onAction && (
          <PrimaryButton onClick={onAction}>
            <Plus className="w-4 h-4 mr-2" />
            {actionLabel}
          </PrimaryButton>
        )}
      </CardContent>
    </Card>
  );
};

export default EmptyState;
